import { render, staticRenderFns } from "./EmployeeBee.vue?vue&type=template&id=35c6c97f&scoped=true"
import script from "./EmployeeBee.vue?vue&type=script&lang=js"
export * from "./EmployeeBee.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBee.vue?vue&type=style&index=0&id=35c6c97f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6c97f",
  null
  
)

export default component.exports